// extracted by mini-css-extract-plugin
module.exports = {"safeAppTagContainer":"styles_safeAppTagContainer__X3UA8","compact":"styles_compact__FqkRF"};